import { addYears, addMonths, subYears, subMonths, format, differenceInCalendarDays, parseISO, startOfToday, differenceInCalendarYears, differenceInCalendarMonths } from 'date-fns';
import { FORMULATE_DATE_FORMAT } from "@shared/utils/dateTime";
import { YEAR, MONTH, MAX_YEARS, MAX_MONTHS } from './constants';

export const formatDate = (date) => {
  return format(date, FORMULATE_DATE_FORMAT);
};

export const addYearsToDate = (date, count) => {
  return format(addYears(date, Number(count)), FORMULATE_DATE_FORMAT);
};

export const addMonthsToDate = (date, count) => {
  return format(addMonths(date, Number(count)), FORMULATE_DATE_FORMAT);
};

export const subYearsToDate = (date, count) => {
  return format(subYears(date, Number(count)), FORMULATE_DATE_FORMAT);
};

export const subMonthsToDate = (date, count) => {
  return format(subMonths(date, Number(count)), FORMULATE_DATE_FORMAT);
};

export const getDiffInCalendarDays = (date) => {
  return differenceInCalendarDays(Date.now(), new Date(date));
};

export const formatTimeSpanDate = (date) => {
  return format(parseISO(date), FORMULATE_DATE_FORMAT);
};

export const validateTimeSpanDate = (timeSpanDate, timeSpanType) => {
  let result = false;

  if (
    new Date(timeSpanDate) < startOfToday()
    || timeSpanType === YEAR && differenceInCalendarYears(new Date(timeSpanDate), new Date(startOfToday())) > MAX_YEARS
    || timeSpanType === MONTH && differenceInCalendarMonths(new Date(timeSpanDate), new Date(startOfToday())) > MAX_MONTHS
  ) {
    result = true;
  }

  return result;
}